import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f260107e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lifestyle" }
const _hoisted_2 = { class: "pics" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dec" }, [
  /*#__PURE__*/_createTextVNode(" We integrate AI to support and enhance each pillar of lifestyle medicine, "),
  /*#__PURE__*/_createElementVNode("p", null, "ensuring comprehensive and personalised care")
], -1))

import { onMounted, reactive, watchEffect } from "vue";
import { useData } from "@/utils/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'Lifestyle',
  setup(__props) {

const pageData=useData()

const pics = reactive<{
  pic: { url: string; title: string[] }[];
}>({
  pic: [],
});
watchEffect(() => {
  const {PAGE_MODEL_1}=pageData.globalData.value
  if(PAGE_MODEL_1){
    pics.pic=PAGE_MODEL_1
  }
})
onMounted(() => {
  if (localStorage.getItem("PAGE_MODEL_1")) {
    pics.pic = JSON.parse(localStorage.getItem("PAGE_MODEL_1") || "") || [];
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pics.pic, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "pic",
          key: item.url
        }, [
          _createElementVNode("img", {
            src: item.url,
            alt: ""
          }, null, 8, _hoisted_3),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.title, (t) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "text",
              key: t
            }, _toDisplayString(t), 1))
          }), 128))
        ]))
      }), 128))
    ]),
    _hoisted_4
  ]))
}
}

})